import { CommandData } from "../../command/command";
import { GxmlCommand } from "./gxml-command";
export class SetRootNodeCommand extends GxmlCommand {
    constructor(document, rootNode, oldRootNode) {
        super();
        this._document = document;
        this._rootNode = rootNode;
        this._oldRootNode = oldRootNode;
    }
    get id() {
        return SetRootNodeCommandData.ID;
    }
    get document() {
        return this._document;
    }
    get rootNode() {
        return this._rootNode;
    }
    get oldRootNode() {
        return this._oldRootNode;
    }
    get changeRoot() {
        return this._rootNode;
    }
    do() {
        this._document.rootNode = this._rootNode;
        return true;
    }
    undo() {
        this.document.rootNode = this._oldRootNode;
        return true;
    }
    getData() {
        return {
            id: this.id,
            rootNode: this._rootNode.toData(),
            oldRootNodeId: this._oldRootNode.id
        };
    }
}
export var SetRootNodeCommandData;
(function (SetRootNodeCommandData) {
    SetRootNodeCommandData.ID = 'SetRootNode';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === SetRootNodeCommandData.ID
            && 'rootNode' in arg
            && 'oldRootNodeId' in arg;
    }
    SetRootNodeCommandData.is = is;
})(SetRootNodeCommandData || (SetRootNodeCommandData = {}));
//# sourceMappingURL=set-root-node-command.js.map